/**
 * 教程进度排名：服务端只给原始行（谁、哪节、看到哪、看完没），这里按当前课程清单算名次。
 * 只数已上线的课：下线或改名的课 id 不在清单里，自然不计；还没做好的课谁也看不了，算进分母只会让人人都低。
 *
 * 名次：看完的课数多的在前；一样多比累计学习时长（看完的按整节算、没看完的按看到的位置算）；
 * 两项都一样并列同一名。
 */
export interface LearningRankRow { username: string; lesson_id: string; position: number; duration: number; completed: boolean; updated_at: number }
export interface LearnerRank { rank: number; username: string; completed: number; total: number; watchedSec: number; lastAt: number }

export function rankLearners(rows: LearningRankRow[], readyLessonIds: readonly string[]): LearnerRank[] {
  const ready = new Set(readyLessonIds);
  const by = new Map<string, Omit<LearnerRank, "rank">>();
  for (const r of rows) {
    if (!ready.has(r.lesson_id)) continue;
    const me = by.get(r.username) ?? { username: r.username, completed: 0, total: ready.size, watchedSec: 0, lastAt: 0 };
    if (r.completed) me.completed += 1;
    me.watchedSec += r.completed ? r.duration : Math.min(r.position, r.duration);
    me.lastAt = Math.max(me.lastAt, r.updated_at);
    by.set(r.username, me);
  }
  const sorted = [...by.values()].sort((a, b) =>
    b.completed - a.completed || b.watchedSec - a.watchedSec || a.username.localeCompare(b.username));
  const out: LearnerRank[] = [];
  sorted.forEach((x, i) => {
    const prev = out[i - 1];
    const tied = prev && prev.completed === x.completed && prev.watchedSec === x.watchedSec;
    out.push({ ...x, rank: tied ? prev.rank : i + 1 });
  });
  return out;
}
